import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '@/state/IState';
import { ProfileCatalogProduct, ProjectFeeSet } from '@/types';
// import { EditableCatalogProductDisplay } from '@/seller/components/products/ProductDisplay';
import { getProjectFeeSets } from '@/services/fees';
import { ProductCard, ProductCardList } from '../../products/ProductCard';
import { Checkbox } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { ValidatingInput } from '@ygtechnologies/bygr-frontend-component-library';
import { FeePreviewCompact } from '../../fees';
import theme from './LinkToUnit.module.scss';

interface ProductWithPrice extends ProfileCatalogProduct {
    price: number | null;
}

export interface LinkToUnitProductsProps {
    products: ProductWithPrice[];
    setPrice: (id: number, price: number | null) => void;
    defaultProductId: number | null;
    setDefaultProductId: (id: null | number) => void;
    projectFeeSetId: number | null;
    projectId: number | null;
}

export const LinkToUnitProducts: React.FC<LinkToUnitProductsProps> = ({
    products,
    setPrice,
    defaultProductId,
    setDefaultProductId,
    projectFeeSetId,
    projectId,
}) => {
    const [projectFeeSet, setProjectFeeSet] = useState<ProjectFeeSet | null>(null);

    useEffect(() => {
        const loadProjectFeeSet = async () => {
            if (projectId !== null && projectFeeSetId !== null) {
                const feeSet = (await getProjectFeeSets(projectId)).find((x) => x.id === projectFeeSetId);
                setProjectFeeSet(feeSet ? feeSet : null);
            }
        };

        loadProjectFeeSet();
    }, [projectId, projectFeeSetId]);

    return (
        <ProductCardList singleColumn>
            {products.map((p) => (
                <ProductCard
                    key={p.id}
                    catalog="profile"
                    product={p}
                    priceElement={
                        <div className={theme.productPriceContainer}>
                            <div>
                                <Checkbox
                                    inputSize="md"
                                    checked={defaultProductId === p.id}
                                    onChange={(e) => (e.target.checked ? setDefaultProductId(p.id) : null)}>
                                    <Trans>Default</Trans>
                                </Checkbox>
                            </div>
                            <div>
                                <ValidatingInput
                                    className="form-control"
                                    type="number"
                                    value={p.price || 0}
                                    onChange={(e) => setPrice(p.id, +e.target.value)}
                                />
                            </div>
                            <div>
                                <FeePreviewCompact price={p.price || 0} quantity={1} projectFeeSet={projectFeeSet} />
                            </div>
                        </div>
                    }
                />
            ))}
        </ProductCardList>
    );
};
